module.exports = __webpack_public_path__ + "static/Dia-Regular-a112c682fb8eb494ad72b6888a97ed73.woff";